import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const redisCloudContent = EntityContentBlueprint.make({
  name: 'redis-cloud',
  params: {
    path: '/redis',
    title: 'Redis',
    group: 'operation',
    filter: entity =>
      entity.kind.toLocaleLowerCase('en-US') === 'component' &&
      Boolean(
        entity.metadata.annotations?.['redis.com/cloud-subscription-id'],
      ) &&
      Boolean(entity.metadata.annotations?.['redis.com/cloud-database-id']),
    loader: () =>
      import('./RedisCloudContent').then(m => <m.RedisCloudContent />),
  },
});

export const redisCloudModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [redisCloudContent],
});
